import { ProductTypeEnum } from "ReactApp/Types/enum";

/**
 * TODO[justMvp] - просто быстрый набросок единной точки для забора данных
 * по товару для маркетинговых событий.
 */
// потом все это вынести в интерфейсы
export namespace ProductFetcherNs {
    // параметры для запроса
    export interface Params {
        productType: ProductTypeEnum;
        id: number;
    }

    export interface Product {
        // пока для быстроты. потом вынести все из showableProductCard 
        type: ProductTypeEnum;
        marketingProductId: number;
        title: string;
        realModifierId?: number;
        salePrice: object;
        oldPrice: object;
        actualFields: any[];
        currency: string;
    }
}

export class ProductFetcher {
    static async fetchByType(params: ProductFetcherNs.Params): Promise<ProductFetcherNs.Product> {
        const query = new URLSearchParams({
            productTypeId: String(params.productType),
            productId: String(params.id),
        });

        const response = await fetch(
            `/bi/product-info/common?${query.toString()}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

        if (!response.ok) {
            throw new Error(`Ошибка получения товара: ${response.statusText}`);
        }

        return await response.json();
    }
}
